/**
 * Trust Badges
 * Each badge slides in from right to left on page load (or on scroll into
 * view), staggered left-to-right so the row fills in sequentially.
 */
(function () {
  function initTrustBadges(root) {
    if (!root || root.dataset.tbInitialized === 'true') return;
    root.dataset.tbInitialized = 'true';

    var animationEnabled = root.dataset.enableAnimation === 'true';
    var items = root.querySelectorAll('[data-badge-item]');
    if (!items.length) return;

    if (!animationEnabled) return;

    function getStaggerMs() {
      var val = getComputedStyle(root).getPropertyValue('--tb-anim-stagger');
      return parseInt(val, 10) || 0;
    }

    var stagger = getStaggerMs();

    items.forEach(function (item) {
      var index = parseInt(item.dataset.itemIndex, 10) || 0;
      item.classList.add('tb-animate-ready');
      item.style.transitionDelay = (index * stagger) + 'ms';
    });

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything immediately.
      items.forEach(function (item) {
        item.classList.add('tb-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tb-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-trust-badges]').forEach(initTrustBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-trust-badges]');
    if (root) initTrustBadges(root);
  });
})();